export default [
	{
		path: '/test/abilities',
		name: 'Abilities Test',
		component: () => import('@/views/test/AbilitiesTest.vue'),
		meta: {
			layout: 'Default'
		}
	},
    {
		path: '/test/components',
		name: 'Full Components Test',
		component: () => import('@/views/test/FullComponentsTest.vue'),
		meta: {
			layout: 'Default'
		}
	}
]